import React from 'react';
import { Button } from './ui/button';
import { Phone, CheckCircle } from 'lucide-react';

const CTA = ({ onWhatsAppClick }) => {
  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/6980572/pexels-photo-6980572.jpeg"
          alt="Modern Kitchen"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-800/90 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            Water Heater Anda Bermasalah?
            <span className="block text-blue-300 mt-2">Hubungi Kami Sekarang!</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Dapatkan konsultasi gratis dan penawaran terbaik untuk service water heater Anda
          </p>

          {/* Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
            <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4">
              <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0" />
              <span className="font-semibold">Gratis Konsultasi</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4">
              <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0" />
              <span className="font-semibold">Respon Cepat</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4">
              <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0" />
              <span className="font-semibold">Harga Terbaik</span>
            </div>
          </div>

          {/* CTA Button */}
          <Button
            onClick={onWhatsAppClick}
            size="lg"
            className="bg-white text-blue-600 hover:bg-gray-100 px-10 py-7 text-xl font-bold rounded-2xl shadow-2xl hover:shadow-white/50 transition-all duration-300 hover:scale-105"
          >
            <Phone className="w-7 h-7 mr-3" />
            Hubungi via WhatsApp Sekarang
          </Button>

          <p className="mt-6 text-gray-300">
            Atau hubungi: <a href="https://wa.me/6285776282868" className="text-white font-bold hover:text-blue-300 transition-colors">+62 857-7628-2868</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;